import { Grid, Typography, Checkbox } from '@mui/material';

import { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';
import { checkBoxInfo } from 'common/constants/CitationDetails';

import styles from './SummaryApprovalDailog.module.scss';

interface IConfirmationDailog {
	cancelClicked?: any;
	submitClicked?: any;
}
const SummaryApprovalDailog = (props: IConfirmationDailog) => {
	const { cancelClicked, submitClicked } = props;
	const { checkBoxColor, checkBoxCheckedColor } = styles;
	const [selectedCheckBox, setSelectedCheckBox] = useState<number[]>([]);

	const label = {
		inputProps: { 'aria-label': 'Checkbox demo', 'data-testid': 'checkbox' },
	};

	const handleCheckBox = (
		index: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		if ((event.target as HTMLInputElement).checked) {
			setSelectedCheckBox((res) => [...res, index]);
		} else {
			setSelectedCheckBox((res) => res.filter((element) => element !== index));
		}
	};

	const handleConfirmAllCheckBox = (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		if ((event.target as HTMLInputElement).checked) {
			setSelectedCheckBox(
				checkBoxInfo.flatMap((innerArray) => innerArray.map((res) => res.id)),
			);
		} else {
			setSelectedCheckBox([]);
		}
	};

	return (
		<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
			<Grid container direction="column" gap="12px">
				<Typography className={styles['modal-heading']}>
					Approval Confirmation
				</Typography>
				{checkBoxInfo.map((res, id) => (
					<Grid
						container
						direction="row"
						alignItems="normal"
						key={res[id] && res[id].id}
						className={styles['stack-background']}
					>
						{id === 1 && (
							<Typography className={styles['modal-sub-text-heading']}>
								The plain language summary clearly identifies:
							</Typography>
						)}
						{res.map((item) => (
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								display="flex"
								alignItems="center"
								key={item.id}
							>
								<Checkbox
									size="small"
									data-testid="modal-checkbox"
									checked={selectedCheckBox.includes(item.id)}
									onChange={(event) => handleCheckBox(item.id, event)}
									sx={{
										color: checkBoxColor,
										'&.Mui-checked': {
											color: checkBoxCheckedColor,
										},
									}}
								/>
								<Typography className={styles['modal-sub-text']}>
									<span className={styles['modal-sub-text-highlighted']}>
										{item.highlightedText}
									</span>
									{item.text}
								</Typography>
							</Grid>
						))}
					</Grid>
				))}
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					display="flex"
					gap="4px"
				>
					<Grid container alignItems="center" justifyContent="space-between">
						<Grid
							item
							display="flex"
							alignItems="center"
							className={styles['confirm-all-stack']}
						>
							<Checkbox
								size="small"
								{...label}
								data-testid="confirm-all"
								checked={selectedCheckBox.length === 4}
								onChange={(event) => handleConfirmAllCheckBox(event)}
								sx={{
									color: checkBoxColor,
									'&.Mui-checked': {
										color: checkBoxCheckedColor,
									},
								}}
							/>
							<Typography className={styles['modal-sub-text']}>
								Confirm All
							</Typography>
						</Grid>
						<Grid item display="flex" alignItems="center" gap="10px">
							<ButtonComp btnType="secondary" clickHandler={cancelClicked}>
								Cancel
							</ButtonComp>
							<ButtonComp
								btnType="primary"
								clickHandler={submitClicked}
								data-testid="btn-submit"
								disabled={selectedCheckBox.length !== 4}
							>
								Submit
							</ButtonComp>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default SummaryApprovalDailog;
